import {Employee, Team, useApiCall, useApiEndpoint} from "@jane/lib/src/api";
import { Checkbox } from "@jane/lib/src/components/form/Checkbox";
import React, {FC, useMemo, useState} from "react";
import {config} from "../config";
import { useToasts } from "@jane/lib/src/toasts/toasts";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSquareCheck} from "@fortawesome/free-solid-svg-icons";
import {Callout} from "../../../lib/src/components/content/Callout";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const AssignLearnModuleToEmployeeModal: FC<{onFinished: () => void, moduleId: string, employees: Employee[], teamMap: Team[][]}> = (props) => {
  const {learn} = useApiCall(config)
  const [employee, setEmployee] = useState<number|null>(null)
  const [selected, setSelected] = useState<number[]>([])
  const teamOptionsMap: Map<number, [string, number]> = useMemo(() => {
    return new Map([
      ...props.teamMap
        .map<[Team, number]>(teams => {
          const team = teams.slice(-1)[0]
          return [team, teams.length]
        })
        .map<[number, [string, number]]>(([team, indentation]) => [team.id, [team.name, indentation]])
    ])
  }, [props.teamMap])
  const implicitlySelected: number[] = useMemo(() => {
    const childrenOfSelected = selected.map(sel => {
      const teamIdMap = props.teamMap.map(teamPath => teamPath.map(team => team.id))
      const teamMapEntry = teamIdMap.find(teamPath => {
        return teamPath[teamPath.length - 1] === sel
      })
      if (teamMapEntry === undefined) return []
      return teamIdMap
        .filter(teamPath => teamPath.includes(sel))
        .flat()
        .filter(t => ! teamMapEntry.includes(t))
    })
    const uniqueChildren = new Set<number>(childrenOfSelected.flat())
    return Array.from(uniqueChildren).filter(c => !selected.includes(c))
  }, [selected, props.teamMap])

  const selectedEmployees = useMemo(() => {
    return props.employees.filter(e => {
      return e.team_id !== null && (
        selected.includes(e.team_id) ||
        implicitlySelected.includes(e.team_id)
      )
    })
  }, [selected, implicitlySelected, props.employees])

  const toasts = useToasts()

  const save = async () => {
    // TODO: Finish this...
    await learn.assignModuleToEmployees(props.moduleId, selectedEmployees.map(e => e.id))
    toasts.showToast('Onderwerp toegewezen', `De relevante personen krijgen hier een melding van.`)
    props.onFinished()
  }
  return <div className={"flex flex-col"}>
    {Array.from(teamOptionsMap.entries()).map((entry, i) => {
      const [teamId, [teamName, indentation]] = entry
      const isSelected = selected.includes(teamId)
      const isImplicitlySelected = implicitlySelected.includes(teamId)
      return <div key={i} className={'flex items-center'} style={{paddingLeft: `${(indentation-1) * 20}px`}}>
        {isImplicitlySelected ? <>
          <div className={"flex items-center cursor-pointer text-on-surface max-w-md px-3 py-2 rounded-lg opacity-60"}>
            <FontAwesomeIcon className={"text-brand-secondary text-xl"} icon={faSquareCheck} />
            <div className={"flex flex-col ml-4"}>
              <span className={'text-sm font-medium'}>{teamName}</span>
            </div>
          </div>
        </> : <>
          <Checkbox checked={isSelected} onChange={() => setSelected(old => isSelected ? old.filter(x => x !== teamId) : [...old, teamId])} label={teamName} />
        </>}
      </div>
    })}
    <Callout color={'primary'}>
      Je hebt <strong>{selectedEmployees.length}</strong> medewerkers geselecteerd.
    </Callout>
    <ModalFooter text={'Opslaan'} onSubmit={save}/>
  </div>
}
